/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Experience_Stopped_HintInputs */

const en_us2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We come back calmly, faster than from scratch`)
};

const pt_br2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltamos com calma, mais rápido que do zero`)
};

const es_419_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volvemos con calma, más rápido que desde cero`)
};

const pt_pt2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltamos com calma, mais depressa do que do zero`)
};

const fr_fr2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On reprend en douceur, plus vite que de zéro`)
};

const de_de2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir steigen ruhig wieder ein, schneller als bei null`)
};

const it_it2_profile_editors_experience_stopped_hint = /** @type {(inputs: Profile_Editors_Experience_Stopped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripartiamo con calma, più in fretta che da zero`)
};

/**
* | output |
* | --- |
* | "We come back calmly, faster than from scratch" |
*
* @param {Profile_Editors_Experience_Stopped_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_experience_stopped_hint = /** @type {((inputs?: Profile_Editors_Experience_Stopped_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Experience_Stopped_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_experience_stopped_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_experience_stopped_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_experience_stopped_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_experience_stopped_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_experience_stopped_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_experience_stopped_hint(inputs)
	return en_us2_profile_editors_experience_stopped_hint(inputs)
});
export { profile_editors_experience_stopped_hint as "profile-editors.experience_stopped_hint" }